import { memo } from "react";
import { colors, fonts, glyphs } from "../../../Styles";
import { DeviceInfo } from "../../../Services";
import { TerminalDataProps } from "../_GlobalComponents/editTerminalsData";
import { BaseIO } from "../../GlobalModals/editSectionModal";

const LocationPopper = memo(({locationData}:{locationData:TerminalDataProps[]}) => {
  return locationData.map((location, index) => {
    if (!location) return null;

    const _fontStyle = { ...fonts.paragraph, ...fonts.fontSize4, ...fonts.fontWeight1, color: colors.greyLightTertiary }
    const _headerStyle = { ...fonts.fontSize4, ...fonts.header, color: colors.greyPrimary }

    const renderRow = (item: BaseIO, index: number) => (
      <div key={`popper_${location.location_id}_${index}`} style={{ display: "grid", gridTemplateColumns: "1fr 40px 1fr 20px", gap: "10px"}}>
        
        {/* Text */}
        <p style={{ ..._fontStyle }}>{item.text}:</p>

        {/* Port */}
        <p style={{ ..._fontStyle }}>{Number(item.boardDisabled ? item.sensor_p : item.port) - (item.offset === 1 ? 100 : item.offset === 2 ? 200 : 0)}</p>
        
        {/* Board */}
        <p style={{ ..._fontStyle }}>{item.board?.name}</p>

        {/* Disabled */}
        {item.programmedDisabled === false ? <glyphs.Check fillColor={colors.systemGreen}/> : <glyphs.Minus fillColor={colors.systemRed}/>}
      </div>
    );

    return (
      <div key={`popper_pen_${location.location_id}_${index}`} style={{ }}>
        
        <div style={{ gridArea: "2/1/3/4", display: "flex", flexDirection: "column" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 40px 1fr 20px", gap: "10px", marginBottom: "5px"}}>
            <p style={{ ..._headerStyle }}></p>
            <p style={{ ..._headerStyle }}>Port</p>
            <p style={{ ..._headerStyle }}>I/O Board</p>
            <p style={{ ..._headerStyle }}>On</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            {location.terminals.map((item, i) => renderRow(item, i))}
          </div>
        </div>
      </div>
    );
  });
});

export default LocationPopper